import { useState, useEffect, useRef, useMemo } from "react";

import { useDispatch, useSelector } from "react-redux";

import Button from "../../components/utils/Button";

import { useForm } from "react-hook-form";

import moment from "moment";

import Calendar2LineIcon from "remixicon-react/Calendar2LineIcon";

import DatePicker from "react-datepicker";

import CardLayout from "../../components/utils/CardLayout";

import SideButtons from "../../components/utils/SideButtons";

import SearchBar from "../../components/utils/SearchBar";

import Table from "../../components/utils/Table";

import DataTable from "../../components/utils/DataTableClient";

import Modal from "../../components/utils/Model";

import Alert from "../../components/utils/Alert";

import EyeFill from "remixicon-react/EyeFillIcon";

import MDNForm from "./MDNForm";
import mdnSwapAction from "../../redux/MDNSwap/actions";

// ============================================
// LIST API
// ============================================

import rechargeRequestAction from "../../redux/rechargeRequest/actions";

// ============================================
// OTHER ACTIONS
// ============================================

import networkActions from "../../redux/network/actions";

import shortCodeActions from "../../redux/shortCodeData/actions";

import AggregatorActions from "../../redux/aggregator/actions";

import authActions from "../../redux/auth/actions";

// ============================================
// HELPERS
// ============================================

import {
  convertDateTimeToRequiredFormatTZ,
  isAdmin,
  isAdminAgent,
  isDealer,
} from "../../helpers/commonFunction";

// ============================================
// ACTION DESTRUCTURING
// ============================================

const { createMdnSwapRequest } = mdnSwapAction;

const { getRechargeRequest } = rechargeRequestAction;

const { getActiveNetwork } = networkActions;

const { getShortCode } = shortCodeActions;

const { getAggregator } = AggregatorActions;

const { getUserDataByToken } = authActions;

// ============================================
// COMPONENT
// ============================================

function MDNSwap() {
  const dispatch = useDispatch();

  // ==========================================
  // REFS
  // ==========================================

  const datePickerRef = useRef(null);

  const datePickerRef2 = useRef(null);

  // ==========================================
  // STATES
  // ==========================================

  const [pageNo, setPageNo] = useState(0);

  const [filterText, setFilterText] = useState("");

  const [showAlert, setShowAlert] = useState(false);

  const [alertType, setAlertType] = useState("");

  const [alertText, setAlertText] = useState("");

  const [toDate, setToDate] = useState(new Date());

  const [fromDate, setFromDate] = useState(
    new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000),
  );

  // ==========================================
  // BATCH MODAL
  // ==========================================

  const [showBatchModal, setShowBatchModal] = useState(false);

  const [selectedBatch, setSelectedBatch] = useState(null);

  const [batchDetails, setBatchDetails] = useState([]);

  // ==========================================
  // MDN SWAP REDUX
  // ==========================================

  const { createMdnSwapLoading, createMdnSwapMessage, createMdnSwapError } =
    useSelector((state) => state.mdnSwap);

  // ==========================================
  // RECHARGE LIST REDUX
  // ==========================================

  const { getRechargeReuestList, getRechargeReuestLoading } = useSelector(
    (state) => state.rechargeRequest,
  );

  // ==========================================
  // OTHER REDUX
  // ==========================================

  const { tokenData } = useSelector((state) => state.auth);

  const { networkResult } = useSelector((state) => state.network);

  const { shortCodeResult } = useSelector((state) => state.shortCode);

  const { list: aggregatorList } = useSelector((state) => state.aggregator);

  // ==========================================
  // FORM
  // ==========================================

  const { register, handleSubmit, getValues } = useForm({
    defaultValues: {
      statusID: "",
      networkID: "",
      aggregatorID: "",
      MSISDN: "",
    },
  });

  const searchValues = getValues();

  const searchData = useMemo(() => {
    return {
      ...searchValues,

      toDate: moment(toDate).format("YYYY-MM-DD"),

      fromDate: moment(fromDate).format("YYYY-MM-DD"),
    };
  }, [searchValues, toDate, fromDate]);

  // ==========================================
  // INITIAL API CALL
  // ==========================================

  useEffect(() => {
    dispatch(getRechargeRequest(searchData));

    dispatch(getActiveNetwork());

    dispatch(getAggregator());

    dispatch(
      getShortCode({
        tableName: "activationrequest",

        fieldName: "RequestStatus",
      }),
    );
  }, [dispatch]);

  // ==========================================
  // MDN SWAP ALERT
  // ==========================================

  useEffect(() => {
    if (createMdnSwapError !== null && createMdnSwapError !== undefined) {
      displayAlert(createMdnSwapError, "alert-danger");
    }

    if (createMdnSwapMessage !== null && createMdnSwapMessage !== undefined) {
      displayAlert(createMdnSwapMessage, "alert-success");

      dispatch(getUserDataByToken());

      // Refresh table
      dispatch(getRechargeRequest(searchData));
    }
  }, [createMdnSwapError, createMdnSwapMessage, dispatch]);

  // ==========================================
  // ALERT
  // ==========================================

  const displayAlert = (text, type) => {
    setAlertText(text);

    setAlertType(type);

    setShowAlert(true);
  };

  const alertCancel = () => {
    setShowAlert(false);

    setAlertText("");

    setAlertType("");
  };

  // ==========================================
  // SEARCH
  // ==========================================

  const handleFilterChange = (value) => {
    setFilterText(value);
  };

  const onSubmit = (data) => {
    const searchRequest = {
      ...data,

      toDate: moment(toDate).format("YYYY-MM-DD"),

      fromDate: moment(fromDate).format("YYYY-MM-DD"),
    };

    dispatch(getRechargeRequest(searchRequest));
  };

  // ==========================================
  // OPEN MDN SWAP FORM
  // ==========================================

  const handleRechargeForm = () => {
    setPageNo(1);
  };

  const handleRechargeFormBack = () => {
    setPageNo(0);
  };

  // ==========================================
  // CREATE MDN SWAP
  // ==========================================

  const handleCreateMdnSwap = (formData) => {
    dispatch(createMdnSwapRequest(formData));
  };

  // ==========================================
  // BATCH CLICK
  // ==========================================

  const handleBatchClick = (e, row) => {
    e.preventDefault();

    setSelectedBatch(row);

    const details =
      row?.Details ||
      row?.details ||
      row?.DetailData ||
      row?.detailData ||
      row?.Items ||
      row?.items ||
      row?.Records ||
      row?.records ||
      [];

    if (Array.isArray(details)) {
      setBatchDetails(details);
    } else {
      setBatchDetails([]);
    }

    setShowBatchModal(true);
  };

  // ==========================================
  // CLOSE MODAL
  // ==========================================

  const closeBatchModal = () => {
    setShowBatchModal(false);

    setSelectedBatch(null);

    setBatchDetails([]);
  };

  // ==========================================
  // MAIN TABLE COLUMNS
  // ==========================================

  const columns = [
    {
      name: "#",

      selector: (row) => row.id,

      sortable: true,

      width: "80px",

      center: true,
    },

    {
      name: "REFERENCE",

      cell: (row) => (
        <div className="flex flex-col py-2">
          <div>
            <strong>Batch TXNID:</strong>{" "}
            <span
              onClick={(e) => handleBatchClick(e, row.originalRow)}
              style={{
                cursor: "pointer",
                color: "#990404",
                fontWeight: 600,
                textDecoration: "underline",
              }}
              title="View Details"
            >
              {row.batchtransactionid || "-"}
            </span>
          </div>

          <div className="my-2">
            <strong>Dealer Name:</strong> {row.dealername || "-"}
          </div>

          <div>
            <strong>Dealer Email:</strong> {row.dealeremail || "-"}
          </div>
        </div>
      ),

      width: "330px",
    },

    {
      name: "NETWORK",

      selector: (row) => row.network,

      width: "150px",
    },

    {
      name: "QUANTITY",

      cell: (row) => (
        <div
          style={{
            display: "flex",
            gap: "6px",
            alignItems: "center",
          }}
        >
          <span
            style={{
              minWidth: "31px",
              height: "35px",
              padding: "0 8px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "6px",
              backgroundColor: "#2db84d",
              color: "#fff",
              fontWeight: "700",
            }}
          >
            {row.successquantity}
          </span>

          <span
            style={{
              minWidth: "31px",
              height: "35px",
              padding: "0 8px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "6px",
              backgroundColor: "#f44343",
              color: "#fff",
              fontWeight: "700",
            }}
          >
            {row.failedquantity}
          </span>

          <span
            style={{
              minWidth: "31px",
              height: "35px",
              padding: "0 8px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "6px",
              backgroundColor: "#a5a5a5",
              color: "#fff",
              fontWeight: "700",
            }}
          >
            {row.totalquantity}
          </span>
        </div>
      ),

      width: "180px",
    },

    {
      name: "AMOUNT",

      selector: (row) => row.amount,

      width: "130px",
    },

    {
      name: "STATUS",

      cell: (row) => {
        let backgroundColor = "#999999";

        if (row.status === "Completed") {
          backgroundColor = "#2db84d";
        } else if (row.status === "Cancelled") {
          backgroundColor = "#dc3545";
        } else if (row.status === "Processing") {
          backgroundColor = "#ffc107";
        }

        return (
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "9px 13px",
              borderRadius: "6px",
              color: "#fff",
              fontSize: "13px",
              fontWeight: "700",
              backgroundColor,
            }}
          >
            {row.status}
          </span>
        );
      },

      width: "130px",
    },

    {
      name: "SUBMITTED DATE",

      selector: (row) => row.submitteddate,

      width: "180px",
    },

    {
      name: "ACTION",

      cell: (row) => (
        <span
          onClick={(e) => handleBatchClick(e, row.originalRow)}
          style={{
            cursor: "pointer",
          }}
          title="View"
        >
          <EyeFill
            size="1.2em"
            style={{
              color: "#294c28eb",
            }}
          />
        </span>
      ),

      width: "100px",

      center: true,
    },
  ];

  // ==========================================
  // FILTER
  // ==========================================

  const filteredItems = Array.isArray(getRechargeReuestList)
    ? getRechargeReuestList.filter((item) => {
        if (typeof filterText !== "string") {
          return false;
        }

        if (typeof item !== "object" || item === null) {
          return false;
        }

        return Object.values(item).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(filterText.toLowerCase()),
        );
      })
    : [];

  // ==========================================
  // TABLE DATA
  // ==========================================

  const data = filteredItems.map((row, key) => {
    const successQuantity =
      row.SuccessQuantity ??
      row.SuccessfulQuantity ??
      row.CompletedQuantity ??
      row.SuccessCount ??
      0;

    const failedQuantity =
      row.FailedQuantity ?? row.FailQuantity ?? row.FailedCount ?? 0;

    const totalQuantity =
      row.Quantity ??
      row.TotalQuantity ??
      row.TotalCount ??
      Number(successQuantity) + Number(failedQuantity);

    const status =
      row.RequestStatus === 13
        ? "Cancelled"
        : row.RequestStatus === 11
          ? "Processing"
          : row.RequestStatus === 10
            ? "Pending"
            : row.RequestStatus === 32
              ? "Picked"
              : row.Status === "Partial"
                ? "Partial"
                : "Completed";

    return {
      id: key + 1,

      originalRow: row,

      batchtransactionid:
        row.TransactionID ||
        row.TXNID ||
        row.BatchTXNID ||
        row.BulkTransactionID ||
        "-",

      dealername: row.DealerName || row.dealerName || "-",

      dealeremail:
        row.DealerEmail || row.ContactEmailID || row.contactEmail || "-",

      network: row.NetworkName || row.Network || "-",

      successquantity: successQuantity,

      failedquantity: failedQuantity,

      totalquantity: totalQuantity,

      amount: `$${Number(
        row.Amount ?? row.PlanPrice ?? row.TotalChargeAmt ?? 0,
      ).toFixed(2)}`,

      status,

      submitteddate: row.SubmissionDate
        ? convertDateTimeToRequiredFormatTZ(row.SubmissionDate)
        : row.RequestedDtTm
          ? convertDateTimeToRequiredFormatTZ(row.RequestedDtTm)
          : "",
    };
  });

  // ==========================================
  // DATE PICKER
  // ==========================================

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const openDatePicker2 = () => {
    if (datePickerRef2.current) {
      datePickerRef2.current.setOpen(true);
    }
  };

  // ==========================================
  // MODAL COLUMNS
  // ==========================================

  const modalColumns = [
    {
      displayName: "#",
      key: "srNo",
    },

    {
      displayName: "TRANSACTIONID",
      key: "transactionID",
    },

    {
      displayName: "SERIAL NUMBER",
      key: "serialNumber",
    },

    {
      displayName: "IMEI",
      key: "imei",
    },

    {
      displayName: "PHONE NUMBER",
      key: "phoneNumber",
    },

    {
      displayName: "PIN",
      key: "pin",
    },

    {
      displayName: "ACCOUNT NUMBER",
      key: "accountNumber",
    },

    {
      displayName: "AREA CODE",
      key: "areaCode",
    },

    {
      displayName: "NETWORK",
      key: "network",
    },
  ];

  // ==========================================
  // MODAL DATA
  // ==========================================

  const modalData = batchDetails.map((item, index) => ({
    srNo: index + 1,

    transactionID:
      item.TransactionID || item.TXNID || item.TransactionId || "-",

    serialNumber:
      item.SerialNumber ||
      item.Serial_Number ||
      item.SERIALNUMBER ||
      item.SerialNo ||
      "-",

    imei: item.IMEI || item.Imei || "-",

    phoneNumber:
      item.PhoneNumber || item.MSISDN || item.MDN || item.Phone || "-",

    pin: item.PIN || item.Pin || "-",

    accountNumber:
      item.AccountNumber || item.AccountNo || item.Account_Number || "-",

    areaCode: item.AreaCode || item.ZipCode || "-",

    network: item.NetworkName || item.Network || "-",
  }));

  // ==========================================
  // RETURN
  // ==========================================

  return (
    <>
      {pageNo === 1 ? (
        <MDNForm
          back={handleRechargeFormBack}
          search={searchData}
          onSubmit={handleCreateMdnSwap}
          loading={createMdnSwapLoading}
        />
      ) : (
        <CardLayout title="MDN Swap">
          {/* SEARCH FORM */}

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-row">
              {/* NETWORK */}

              <div className="col-lg-2 col-md-4 mb-2">
                <label>Select Network</label>

                <select className="form-control" {...register("networkID")}>
                  <option value="">All</option>

                  {networkResult
                    ?.filter((item) => item.IsActive == 1)
                    .map((item) => (
                      <option value={item.ID} key={item.ID}>
                        {item.NetworkName}
                      </option>
                    ))}
                </select>
              </div>

              {/* AGGREGATOR */}

              {(isAdmin(tokenData) || isAdminAgent(tokenData)) && (
                <div className="col-lg-2 col-md-4 mb-2">
                  <label>Select Aggregator</label>

                  <select
                    className="form-control"
                    {...register("aggregatorID")}
                  >
                    <option value="">All</option>

                    {aggregatorList
                      ?.filter((item) => item.IsActive)
                      .map((item) => (
                        <option value={item.ID} key={item.ID}>
                          {item.ID}
                        </option>
                      ))}
                  </select>
                </div>
              )}

              {/* STATUS */}

              <div className="col-lg-2 col-md-4 mb-2">
                <label>Select Status</label>

                <select className="form-control" {...register("statusID")}>
                  <option value="">All</option>

                  {shortCodeResult
                    ?.filter((item) => item.ID !== 47 && item.ID !== 49)
                    .map((item) => (
                      <option value={item.ID} key={item.ID}>
                        {item.Value}
                      </option>
                    ))}
                </select>
              </div>

              {/* FROM DATE */}

              <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
                <label>From Date</label>

                <Calendar2LineIcon
                  onClick={openDatePicker}
                  size="1.5rem"
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    top: "36px",
                    right: "12px",
                    zIndex: 1,
                  }}
                />

                <DatePicker
                  ref={datePickerRef}
                  selected={fromDate}
                  className="form-control"
                  onChange={(date) => setFromDate(date)}
                  dateFormat="yyyy-MM-dd"
                  showMonthDropdown
                  showYearDropdown
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>

              {/* TO DATE */}

              <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
                <label>To Date</label>

                <Calendar2LineIcon
                  onClick={openDatePicker2}
                  size="1.5rem"
                  style={{
                    cursor: "pointer",
                    position: "absolute",
                    top: "36px",
                    right: "12px",
                    zIndex: 1,
                  }}
                />

                <DatePicker
                  ref={datePickerRef2}
                  selected={toDate}
                  className="form-control"
                  onChange={(date) => setToDate(date)}
                  dateFormat="yyyy-MM-dd"
                  showMonthDropdown
                  showYearDropdown
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>

              {/* MSISDN */}

              <div className="col-lg-2 mb-2">
                <label>MSISDN</label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter MSISDN"
                  {...register("MSISDN")}
                />
              </div>

              {/* SEARCH */}

              <div className="mt-4">
                <Button
                  title="Search"
                  style={{
                    minWidth: 80,
                  }}
                  buttonClass="btn btn-primary mt-1 btn-md"
                  buttonType="submit"
                />
              </div>
            </div>
          </form>

          <hr />

          {/* SEARCH BAR */}

          <div className="row mb-3">
            <div className="col-lg-3 col-md-6">
              <SearchBar
                onFilter={handleFilterChange}
                filterText={filterText}
              />
            </div>

            {isDealer(tokenData) && (
              <div className="col-lg-9 d-flex justify-content-end">
                <SideButtons title="MDN Swap" onClick={handleRechargeForm} />
              </div>
            )}
          </div>

          {/* ALERT */}

          {showAlert && (
            <Alert type={alertType} text={alertText} closeBtn={alertCancel} />
          )}

          {/* TABLE */}

          <div id="activationRequestTable">
            <DataTable
              columns={columns}
              data={data}
              loading={getRechargeReuestLoading}
              customStyles={{
                headRow: {
                  style: {
                    backgroundColor: "#FFF5F5",
                  },
                },

                headCells: {
                  style: {
                    fontWeight: "bold",
                    fontSize: "14px",
                  },
                },
              }}
            />
          </div>
        </CardLayout>
      )}

      {/* ========================================
          BATCH DETAIL MODAL
      ======================================== */}

      <Modal
        showModal={showBatchModal}
        title="Batch Details : "
        subTitle={
          <span
            style={{
              color: "#990404",
            }}
          >
            {selectedBatch?.TransactionID ||
              selectedBatch?.TXNID ||
              selectedBatch?.BatchTXNID ||
              selectedBatch?.BulkTransactionID ||
              ""}
          </span>
        }
        onHide={closeBatchModal}
        width={1000}
        showFooter={false}
      >
        <div
          style={{
            overflowX: "auto",
          }}
        >
          <Table
            columns={modalColumns}
            data={modalData}
            pagination={false}
            loading={false}
          />
        </div>
      </Modal>
    </>
  );
}

export default MDNSwap;
